const config = {
    ROOT_URL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "",
    DL_URL: process.env.REACT_APP_DEBUG_DL_ROUTE ? process.env.REACT_APP_DEBUG_DL_ROUTE: '',
}
export default config
